export enum Jurisdictions {
  AL = 'AL',
  AK = 'AK',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  DC = 'DC',
  FL = 'FL',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VI = 'VI',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
}

export const states = [
  {
    secondaryLabel: 'Alabama',
    label: Jurisdictions.AL,
    value: Jurisdictions.AL,
  },
  {
    secondaryLabel: 'Alaska',
    label: Jurisdictions.AK,
    value: Jurisdictions.AK,
  },
  {
    secondaryLabel: 'Arizona',
    label: Jurisdictions.AZ,
    value: Jurisdictions.AZ,
  },
  {
    secondaryLabel: 'Arkansas',
    label: Jurisdictions.AR,
    value: Jurisdictions.AR,
  },
  {
    secondaryLabel: 'California',
    label: Jurisdictions.CA,
    value: Jurisdictions.CA,
  },
  {
    secondaryLabel: 'Colorado',
    label: Jurisdictions.CO,
    value: Jurisdictions.CO,
  },
  {
    secondaryLabel: 'Connecticut',
    label: Jurisdictions.CT,
    value: Jurisdictions.CT,
  },
  {
    secondaryLabel: 'Delaware',
    label: Jurisdictions.DE,
    value: Jurisdictions.DE,
  },
  {
    secondaryLabel: 'District of Columbia',
    label: Jurisdictions.DC,
    value: Jurisdictions.DC,
  },
  {
    secondaryLabel: 'Florida',
    label: Jurisdictions.FL,
    value: Jurisdictions.FL,
  },
  {
    secondaryLabel: 'Georgia',
    label: Jurisdictions.GA,
    value: Jurisdictions.GA,
  },
  { secondaryLabel: 'Guam', label: Jurisdictions.GU, value: Jurisdictions.GU },
  {
    secondaryLabel: 'Hawaii',
    label: Jurisdictions.HI,
    value: Jurisdictions.HI,
  },
  { secondaryLabel: 'Idaho', label: Jurisdictions.ID, value: Jurisdictions.ID },
  {
    secondaryLabel: 'Illinois',
    label: Jurisdictions.IL,
    value: Jurisdictions.IL,
  },
  {
    secondaryLabel: 'Indiana',
    label: Jurisdictions.IN,
    value: Jurisdictions.IN,
  },
  { secondaryLabel: 'Iowa', label: Jurisdictions.IA, value: Jurisdictions.IA },
  {
    secondaryLabel: 'Kansas',
    label: Jurisdictions.KS,
    value: Jurisdictions.KS,
  },
  {
    secondaryLabel: 'Kentucky',
    label: Jurisdictions.KY,
    value: Jurisdictions.KY,
  },
  {
    secondaryLabel: 'Louisiana',
    label: Jurisdictions.LA,
    value: Jurisdictions.LA,
  },
  { secondaryLabel: 'Maine', label: Jurisdictions.ME, value: Jurisdictions.ME },
  {
    secondaryLabel: 'Maryland',
    label: Jurisdictions.MD,
    value: Jurisdictions.MD,
  },
  {
    secondaryLabel: 'Massachusetts',
    label: Jurisdictions.MA,
    value: Jurisdictions.MA,
  },
  {
    secondaryLabel: 'Michigan',
    label: Jurisdictions.MI,
    value: Jurisdictions.MI,
  },
  {
    secondaryLabel: 'Minnesota',
    label: Jurisdictions.MN,
    value: Jurisdictions.MN,
  },
  {
    secondaryLabel: 'Mississippi',
    label: Jurisdictions.MS,
    value: Jurisdictions.MS,
  },
  {
    secondaryLabel: 'Missouri',
    label: Jurisdictions.MO,
    value: Jurisdictions.MO,
  },
  {
    secondaryLabel: 'Montana',
    label: Jurisdictions.MT,
    value: Jurisdictions.MT,
  },
  {
    secondaryLabel: 'Nebraska',
    label: Jurisdictions.NE,
    value: Jurisdictions.NE,
  },
  {
    secondaryLabel: 'Nevada',
    label: Jurisdictions.NV,
    value: Jurisdictions.NV,
  },
  {
    secondaryLabel: 'New Hampshire',
    label: Jurisdictions.NH,
    value: Jurisdictions.NH,
  },
  {
    secondaryLabel: 'New Jersey',
    label: Jurisdictions.NJ,
    value: Jurisdictions.NJ,
  },
  {
    secondaryLabel: 'New Mexico',
    label: Jurisdictions.NM,
    value: Jurisdictions.NM,
  },
  {
    secondaryLabel: 'New York',
    label: Jurisdictions.NY,
    value: Jurisdictions.NY,
  },
  {
    secondaryLabel: 'North Carolina',
    label: Jurisdictions.NC,
    value: Jurisdictions.NC,
  },
  {
    secondaryLabel: 'North Dakota',
    label: Jurisdictions.ND,
    value: Jurisdictions.ND,
  },
  { secondaryLabel: 'Ohio', label: Jurisdictions.OH, value: Jurisdictions.OH },
  {
    secondaryLabel: 'Oklahoma',
    label: Jurisdictions.OK,
    value: Jurisdictions.OK,
  },
  {
    secondaryLabel: 'Oregon',
    label: Jurisdictions.OR,
    value: Jurisdictions.OR,
  },
  {
    secondaryLabel: 'Pennsylvania',
    label: Jurisdictions.PA,
    value: Jurisdictions.PA,
  },
  {
    secondaryLabel: 'Puerto Rico',
    label: Jurisdictions.PR,
    value: Jurisdictions.PR,
  },
  {
    secondaryLabel: 'Rhode Island',
    label: Jurisdictions.RI,
    value: Jurisdictions.RI,
  },
  {
    secondaryLabel: 'South Carolina',
    label: Jurisdictions.SC,
    value: Jurisdictions.SC,
  },
  {
    secondaryLabel: 'South Dakota',
    label: Jurisdictions.SD,
    value: Jurisdictions.SD,
  },
  {
    secondaryLabel: 'Tennessee',
    label: Jurisdictions.TN,
    value: Jurisdictions.TN,
  },
  { secondaryLabel: 'Texas', label: Jurisdictions.TX, value: Jurisdictions.TX },
  { secondaryLabel: 'Utah', label: Jurisdictions.UT, value: Jurisdictions.UT },
  {
    secondaryLabel: 'Vermont',
    label: Jurisdictions.VT,
    value: Jurisdictions.VT,
  },
  {
    secondaryLabel: 'Virgin Islands',
    label: Jurisdictions.VI,
    value: Jurisdictions.VI,
  },
  {
    secondaryLabel: 'Virginia',
    label: Jurisdictions.VA,
    value: Jurisdictions.VA,
  },
  {
    secondaryLabel: 'Washington',
    label: Jurisdictions.WA,
    value: Jurisdictions.WA,
  },
  {
    secondaryLabel: 'West Virginia',
    label: Jurisdictions.WV,
    value: Jurisdictions.WV,
  },
  {
    secondaryLabel: 'Wisconsin',
    label: Jurisdictions.WI,
    value: Jurisdictions.WI,
  },
  {
    secondaryLabel: 'Wyoming',
    label: Jurisdictions.WY,
    value: Jurisdictions.WY,
  },
];
